
import { useContext } from "react";
import { usePathname } from "next/navigation";
import { cn } from "@/lib/utils";
import { useTranslation } from "@/app/i18n/client";
import ColorStyleContext from "@/lib/providers/color-style-privider";
import { getBaseUrl } from "@/util/get-base-url";
import { makeBaseComponentId } from "@/util/make-component-id";

interface ArticleCardDefaultProps {
    articleItem: any;
    priorityImage?: boolean;
    formattedDate?: string;
    loc: string;
}

const ArticleCardDefault = (props: ArticleCardDefaultProps) => {
    
    const { articleItem, priorityImage, formattedDate, loc } = props;
    const { t } = useTranslation(loc);
    const colorStyle = useContext(ColorStyleContext);
    const pathname = usePathname();

    const pathPrefix = pathname.includes("/business") ? "/business/blogs/editorial" : "/blogs/editorial";

    console.log("pathname in article card default: ", pathname);

    return (
        <div 
            id={`article-carousel-embla-slide-${articleItem.id}`}
            key={articleItem.id}
            className={`related-article w-full p-0 flex flex-col items-start h-full rounded-lg overflow-hidden`}
            /* Ensure card stretches to its allocated carousel column width */
        >   
            <a 
                id={makeBaseComponentId("article-card-picture-link", `article-card-picture-link-${articleItem.id}`)} 
                href={`${pathPrefix}/${articleItem.handle}`}
                className="w-full h-auto"
            >
                <picture id={makeBaseComponentId("article-card-picture", `article-card-picture-${articleItem.id}`)} className="block w-full h-auto">
                    <source
                        srcSet={
                            articleItem.imageUrl != ""
                                ? `${getBaseUrl(articleItem.imageUrl)}.avif`
                                : "https://dummyimage.com/388x200/e9e9e9/e9e9e9.jpg"
                        }
                        type="image/avif"
                    />
                    <source
                        srcSet={
                            articleItem.imageUrl != ""
                                ? `${getBaseUrl(articleItem.imageUrl)}.webp`
                                : "https://dummyimage.com/388x200/e9e9e9/e9e9e9.jpg"
                        }
                        type="image/webp"
                    />
                    <img
                        id={makeBaseComponentId("article-card-img", `article-card-img-${articleItem.id}`)}
                        src={articleItem.imageUrl}
                        alt={articleItem.imageAlt || articleItem.attributes?.title}
                        width={388}
                        height={200}
                        className={cn("object-cover aspect-[19/10] rounded-lg w-full h-auto")}
                        // priority={priorityImage ? true : undefined}
                        loading={priorityImage ? "eager" : "lazy"}
                        onError={(e) => {
                            e.currentTarget.onerror = null;
                            e.currentTarget.src = "https://dummyimage.com/388x200/e9e9e9/e9e9e9.jpg";
                        }}
                    />
                </picture>
            </a>
            <div
                id={makeBaseComponentId("article-card-content", `article-card-content-${articleItem.id}`)}
                className="flex flex-col items-start w-full h-auto gap-3 mt-4"
                style={{ backgroundColor: colorStyle?.contentBg || "#ffffff" }}>
                <p
                    id={makeBaseComponentId("article-card-date-title", `article-card-date-title-${articleItem.id}`)}
                    className="text-[16px] font-normal text-wrap text-ellipsis line-clamp-1"
                    style={
                        {
                            color: colorStyle?.tableText || "#747474",
                        } as React.CSSProperties
                    }>
                    {formattedDate}
                </p>
                <h2
                    id={makeBaseComponentId("article-card-title", `article-card-title-${articleItem.id}`)}
                    className="text-[18px] font-semibold text-wrap text-ellipsis line-clamp-2">
                    {articleItem.attributes?.title}
                </h2>
                <a
                    id={makeBaseComponentId("article-card-link", `article-card-link-${articleItem.id}`)}
                    href={`${pathPrefix}/${articleItem.handle}`}
                    className="text-[18px] font-semibold dynamic-color break-word overflow-hidden"
                    style={
                        {
                            "--dynamic-color": colorStyle?.link || "#006ef2",
                            "--dynamic-hover-color": colorStyle?.linkHover || "#254b7c",
                            "--dynamic-focus-color": colorStyle?.linkHover || "#254b7c",
                            maxHeight: "calc(2 * 2.8rem)",
                        } as React.CSSProperties
                    }>
                    {t("article.read_more")}
                </a>
            </div>
        </div>
    )
}

export default ArticleCardDefault;